const CountryRoads = [
	'[Verse 1]',
	'Almost heaven, West Virginia,',
	'Blue Ridge Mountains, Shenandoah River.',
	'Life is old there, older than the trees,',
	'younger than the mountains,',
	"Growin' like a breeze.",
	'',
	'[Chorus]',
	'Country Roads, take me home, to the place, I belong,',
	'West Virginia, mountain mama,',
	'take me home, country roads.',
	'',
	'[Verse 2]',
	"All my memories gather 'round her,",
	"miner's lady, stranger to blue water.",
	'Dark and dusty, painted on the sky,',
	'misty taste of moonshine, teardrop in my eye.',
	'',
	'[Chorus]',
	'Country Roads, take me home, to the place, I belong,',
	'West Virginia, mountain mama,',
	'take me home, country roads.',
	'',
	'[Bridge]',
	'I hear her voice in the morning hour she calls me,',
	'The radio reminds me of my home far away.',
	'And driving down the road I get a feeling',
	'That I should have been home yesterday, yesterday.',
	'',
	'[Chorus]',
	'Country Roads, take me home, to the place, I belong,',
	'West Virginia, mountain mama,',
	'take me home, country roads.',
	'Country Roads, take me home,',
	'to the place, I belong,',
	'West Virginia, mountain mama,',
	'take me home, country roads.',
	'Take me home, down country roads,',
	'take me home, down country roads',
];

export default CountryRoads;
